import { getExternalPlatformIdFromInternalPlatformId, 
// RPC method constants
ORBY_GET_PLATFORM_INFORMATION, ORBY_LIST_PLATFORMS_INFORMATION, ORBY_GET_PLATFORMS_SUPPORTED_BY_DEFAULT, ORBY_INITIATE_OAUTH_FLOW, } from "@orb-labs/types";
import { extractPlatformInformations } from "../utils/action_helpers.js";
import { LibraryRequest } from "../actions/library_request.js";
import { extractPlatformInformation } from "../index.js";
export class PlatformActions extends LibraryRequest {
    constructor(library, client, provider) {
        super(library, client, provider);
    }
    async getPlatformInformation(platformId) {
        const orbyPlatformId = getExternalPlatformIdFromInternalPlatformId(platformId);
        const { platform, code, message } = await this.sendRequest(ORBY_GET_PLATFORM_INFORMATION, [{ platformId: orbyPlatformId }]);
        if (code && message) {
            console.error("[getPlatformInformation]", code, message);
            return undefined;
        }
        return extractPlatformInformation(platform);
    }
    async listPlatformsInformation(offset, limit) {
        const { pageInfo, edges, code, message } = await this.sendRequest(ORBY_LIST_PLATFORMS_INFORMATION, [{ offset, limit }]);
        if (code && message) {
            console.error("[listPlatformsInformation]", code, message);
            return undefined;
        }
        return {
            platforms: extractPlatformInformations(edges),
            pageInfo,
        };
    }
    async getPlatformsSupportedByDefault() {
        const { platforms, code, message } = await this.sendRequest(ORBY_GET_PLATFORMS_SUPPORTED_BY_DEFAULT, []);
        if (code && message) {
            console.error("[getPlatformsSupportedByDefault]", code, message);
            return undefined;
        }
        return extractPlatformInformations(platforms);
    }
    async initiateOAuthFlow(platformId, sessionId, parentOrigin) {
        const { authenticationInformation, code, message } = await this.sendRequest(ORBY_INITIATE_OAUTH_FLOW, [
            {
                platformId: getExternalPlatformIdFromInternalPlatformId(platformId),
                sessionId,
                parentOrigin,
            },
        ]);
        if (!authenticationInformation) {
            console.error("[initiateOAuthFlow]", "Failed to get authentication URL");
            return undefined;
        }
        return {
            readOnlyAuthenticationUrl: authenticationInformation.readOnlyAuthenticationUrl,
            readAndWriteAuthenticationUrl: authenticationInformation.readAndWriteAuthenticationUrl,
            provider: authenticationInformation.provider,
        };
    }
}
